import { render, staticRenderFns } from "./controls.vue?vue&type=template&id=037edf1e&"
import script from "./controls.vue?vue&type=script&lang=ts&"
export * from "./controls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports